import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, api, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic214 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const [fromData, setFromData] = useState({
    approvalProcess: "",
    //   b
    responsibilityForSustainabilityInfo: "",
  });

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          approvalProcess:
            res.data.data.GeneralDisclosures2021.governanceBodyRole
              .approvalProcess,
          //   b
          responsibilityForSustainabilityInfo:
            res.data.data.GeneralDisclosures2021.governanceBodyRole
              .responsibilityForSustainabilityInfo,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          governanceBodyRole: { ...fromData },
          submitted2_14: true,
        })
          .then((res) => navigate(`/gri/general-disclosure/2-15/${id}`))
          .catch((err) => console.log(err));
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-15/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe whether the highest governance body hold the responsibility for reviewing and approving the reported sustainability information, including the organization's identified material topics and if so, please describe the specific process the highest governance body follows for reviewing and approving this information.",
      fieldName: "approvalProcess",
    },

    {
      index: "b.",
      heading:
        "If the highest governance body is not responsible for reviewing and approving the reported sustainability information, including material topics, please explain the reason for this structure and who is then responsible for reviewing and approving this information?",
      fieldName: "responsibilityForSustainabilityInfo",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-14 Role of the highest governance body in sustainability reporting"
        {...{
          inputData,
          fromData,
          setFromData,
          disabled: disabled,
          setErrors,
          errors,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic214;
